module.exports = __webpack_public_path__ + "img/denmark-transport-accidents-male.84212cfc.png";